import React, { FC, memo, useEffect, useState, useRef, useMemo } from "react";
import { Button, Card, Tooltip, Icon, Loader, Modal } from "@scuf/common";
import { useSelector } from "react-redux";
import * as pbi from 'powerbi-client';
import { models } from 'powerbi-client';
import { useLocation, useParams, useNavigationType } from "react-router-dom";
import { useAppDispatch } from "src/store";
import { Collapsible } from "../Collapsible/Collapsible";
import { DataTable } from "@scuf/datatable";
import { IOpportunityOrderDetailsModel } from "src/models/IOpportunitiesAPIModel";
import {
  getCurrentOpportunities,
  setDetailedView,
  setCurrentInsightID,
  getCurentOpportunitiesSelector,
  getLastPageBeforeLandingDetailedPage,
  setPaginationCurrentPage,
} from "src/slices/allOpportunitySlice";
import {
  getOpportunitiesDetail,
  getUserAction,
} from "../../services/Opportunities";
import {
  IOpportunityDetailItemModel,
  IUserResponseModel,
} from "../../models/IOpportunitiesAPIModel";
import { GetMoreContext } from "../OpportunityModal/NewCardDesign/GetMoreContext";
import { RejectPopup } from "../OpportunityModal/NewCardDesign/RejectPopup";
import { AcceptPopup } from "../OpportunityModal/NewCardDesign/AcceptPopup";
import { AuditReject } from "../OpportunityModal/NewCardDesign/AuditReject";
import { CompleteTaskActionPopup } from "../OpportunityModal/NewCardDesign/CompleteTaskActionPopup/CompleteTaskActionPopup";
import Notes from "../OpportunityModal/NewCardDesign/Notes/Notes";
import NotesFooter from "./NewCardDesign/Notes/NotesFooter";
import AuditTrailActivity from "../OpportunityModal/NewCardDesign/AuditTrailActivity/AuditTrailActivity";
import {
  ROLE_NAME,
  USER_ROLE,
  OPPORTUNITY_STATUS,
  REJECT_NOTES,
  PROJECT_DOMAIN,
  UNREVIEWED,
  AUDIT_REJECTED_UNREVIEWED,
  BUSINESS_REJECTED_UNREVIEWED,
  REVIEWED_ACTION_COMPLETE,
  REVIEWED_ESCALATED,
  TRACKING_COMPLETE,
  OPPORTUNITIES_API_PATHS,
} from "../../constants/constants";
import {
  OPP_MODAL_BUTTONS,
  REJECT_POPUP_TITLE,
  ACCEPT_POPUP_TITLE,
  MORE_CONTEXT_POPUP_TITLE,
  REQUEST_INPUT_TITLE,
  PO_NUMBERS_COPIED,
  AUDIT_RESPONSE_STATUS,
  MAIL_SENT,
} from "../../constants/constants";
import {
  getOnBoardingAPIData,
  getCurrentRole,
} from "../../slices/onBoardingSlice";
import { ReviewCompletion } from "../OpportunityModal/NewCardDesign/ReviewCompletion/ReviewCompletion";
import {
  getButtonStatus,
  getMoreContextButtonStatus,
  getAuditAcceptButton,
  displayReviewTask,
  getPopUpHeaderTitle,
  getCommentButton,
  getRightFooter,
  getReviewChecklistButton
} from "../../utils/roleAccessUtils";
import { useNavigate } from "react-router-dom";
import { RouteConstants } from "../../constants/constants";
import { toast, ToastContent, Zoom } from "react-toastify";
import {
  updateOpportunity,
  updateTrackingOpportunity,
} from "src/slices/opportunitySlice";
import {
  AcceptOppToast,
  AcceptToastTransition,
} from "../Toasts/AcceptOppToast";
import { Snackbar } from "../Snackbar/Snackbar";
import AnomalyBelt from "./NewCardDesign/AnomalyBelt/AnomalyBelt";
import ReviewButton from "../../components/SummaryStatistics/ReviewButton";
import "./AnomalyDetails.scss";
import { getDetailedView } from "src/slices/allOpportunitySlice";
import { tagEvent, TAG_EVENT_CONST } from "src/utils/analytics/analytics.service.util";
import { DominoTracker } from "../DominoTracker/DominoTracker";
import Acknowledge from "./NewCardDesign/Acknowledge/Acknowledge";
import { ReviewerCheckList } from '../OpportunityModal/NewCardDesign/ReviewerCheckList/ReviewerCheckList';
import FontIcon from "../FontIcon/FontIcon";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Footer as ScufFooter } from '@scuf/common';
import { getMessage } from "src/message/utils";
import axios from "src/utils/APIUtils";

type OppModalAction =
  | "accept"
  | "reject"
  | "notes"
  | "realize"
  | "none"
  | "more-context"
  | "claim-ownership"
  | "audit-reject"
  | "audit-accept"
  | "review-task"
  | "tracking-submit"
  | "business-reject"
  | "business-accept"
  | "share"
  | "share-via-email"
  | "acknowledge"
  | "reviewer-checklist";

// Helper function to extract employee ID or unique identifier from object name
const extractEmpId = (objectName: string): string => {
  if (!objectName) return '';
  // Split at the first underscore and take the first part
  return objectName.split('_')[0].trim();
};

const ContextPDFContent: FC<{insight_id:number, file_name:string, stored_file_name:string, type:string}> = ({insight_id, file_name, stored_file_name, type}) => {
  const [base64PdfData, setBase64PdfData] = useState<string>('');
  useEffect(() => {    
    downladFile();
  }, []);
  const downladFile = async () => {
    axios
      .get(
        `${OPPORTUNITIES_API_PATHS.opportunities}/${insight_id}/downloadtableaupng?file_name=${file_name}&stored_file_name=${stored_file_name}`, //375138-sample-62c3.pdf
        { responseType: 'blob' }
      ).then(async(response) => {
        console.log(response)
        if(response.data.type==='text/xml'){
          const blob = new Blob([response.data], { type: type })
          response.data = blob
        }
        const base64Data = await convertBlobToBase64(response.data);
        console.log('Base64 Data:', base64Data);
        setBase64PdfData(base64Data as string);
      })
  }
  
  const convertBlobToBase64 = async (blob: any) => { // blob data
    return await blobToBase64(blob);
  }
  
  const blobToBase64 = (blob: any) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });
    return (
      <div className='gametime-container'>
        <div className='context-container'>
          {type==='application/pdf'?
            <embed src={`${base64PdfData}`} type={type} className="responsive-image"
              download={'filename.pdf'}>
            </embed>
          : 
          type==='image/png' && base64PdfData ? <img src={base64PdfData} alt="image" width={'100%'}/> :
          
            <iframe
              title='context-modal'
              className='context-frame'
              src={base64PdfData}
            />
          
            // <embed src={`${base64PdfData}`} type={type} className="responsive-image"
            //   download={'filename.pdf'}>
            // </embed>
          }
        </div>
      </div>
    );
  };
  
const ContextContent: FC<{ tableau_link?: string; powerbi_link?: string; emp_id?: string }> = ({ tableau_link, powerbi_link, emp_id }) => {
  const reportContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // If it's a Power BI link, use the Power BI embedding
    if (powerbi_link && reportContainerRef.current) {
      const getReportId = (url: string) => {
        const match = url.match(/reportId=([^&]+)/);
        return match ? match[1] : undefined;
      };

      const reportId = getReportId(powerbi_link);
      
      // Build embed URL with filters for navigation and filter pane hidden
      let embedUrl = powerbi_link;
      if (!embedUrl.includes('filterPaneEnabled=false')) {
        embedUrl += '&filterPaneEnabled=false';
      }
      if (!embedUrl.includes('navContentPaneEnabled=false')) {
        embedUrl += '&navContentPaneEnabled=false';
      }
      
      // Add employee filter if emp_id is provided
      if (emp_id) {
        const filterString = `standard_model_output_gnh_alerts/emp_id eq '${emp_id}'`;
        embedUrl += `&filter=${encodeURIComponent(filterString)}`;
        console.log('ContextContent - Filtering Power BI by emp_id:', emp_id);
      }

      // Create Power BI service instance
      const powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );

      // Configure the embed settings
      const embedConfig: pbi.IEmbedConfiguration = {
        type: 'report',
        embedUrl: embedUrl,
        accessToken: '',
        tokenType: models.TokenType.Embed,
        id: reportId,
        settings: {
          panes: {
            filters: {
              expanded: false,
              visible: false
            },
            pageNavigation: {
              visible: false
            }
          },
          background: models.BackgroundType.Transparent,
          layoutType: models.LayoutType.Custom,
          customLayout: {
            displayOption: models.DisplayOption.FitToWidth
          }
        }
      };

      // Embed the report
      const report = powerbi.embed(reportContainerRef.current, embedConfig);

      // Handle errors
      report.on('error', (event: any) => {
        console.error('Power BI Error:', event.detail);
      });

      // Clean up on unmount
      return () => {
        if (reportContainerRef.current) {
          powerbi.reset(reportContainerRef.current);
        }
      };
    }
  }, [powerbi_link, emp_id]);

  // If Power BI link exists, use Power BI container
  if (powerbi_link) {
    return (
      <div className='gametime-container'>
        <div className='context-container'>
          <div 
            ref={reportContainerRef} 
            className='context-frame'
            style={{ width: '100%', height: '600px' }}
          />
        </div>
      </div>
    );
  }
  
  // Otherwise, use Tableau iframe
  return (
    <div className='gametime-container'>
      <div className='context-container'>
        <iframe
          title='context-modal'
          className='context-frame'
          src={tableau_link}
        />
      </div>
    </div>
  );
};

const PowerBIContent: FC<{ powerbi_link: string; uniqueId?: string; filterType?: 'gnh' | 'diversion' | 'pocut' | 'tracking304' }> = ({ powerbi_link, uniqueId, filterType = 'gnh' }) => {
  const [embedUrl, setEmbedUrl] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    const urlParams = new URLSearchParams(powerbi_link.split('?')[1]);
    const reportId = urlParams.get('reportId');

    if (!reportId) {
      setIsLoading(false);
      return;
    }
    
    let url = `https://app.powerbi.com/reportEmbed?reportId=${reportId}&autoAuth=true&ctid=96ece526-9c7d-48b0-8daf-8b93c90a5d18&filterPaneEnabled=false&navContentPaneEnabled=false`;
    
    // Add filter if uniqueId is provided
    if (uniqueId) {
      // Different filter based on category
      let filterString;
      if (filterType === 'gnh') {
        filterString = `standard_model_output_gnh_alerts/emp_id eq '${uniqueId}'`;
      } else if (filterType === 'diversion') {

        filterString = `standard_model_output_diversion_alerts/sold_to_name eq '${uniqueId}'`;
      } else if (filterType === 'pocut') {
        filterString = `anomaly_central/Unique_ID eq ${uniqueId}`;
      } else if (filterType === 'tracking304') {
        // G&H Trends uses the anomaly ID from insight_summary_object_name (unquoted value).
        filterString = `gnh_trend_alert_released_data/anomaly_id eq ${uniqueId}`;
      }
      if (filterString) {
        // Encode the filter string and replace %20 with + and ' with %27 for Power BI compatibility
        const encodedFilter = encodeURIComponent(filterString)
          .replace(/%20/g, '+')
          .replace(/'/g, '%27');
        url += `&filter=${encodedFilter}`;
        console.log('Power BI URL with filter:', url);
      }
      console.log('Power BI - Applying filter:', url);
    }
    console.log('*******Final Power BI Embed URL:', url);
    setEmbedUrl(url);
    setIsLoading(false);
  }, [powerbi_link, uniqueId, filterType]);
  
  const handleIframeLoad = () => {
    setIsLoading(false);
  };
  
  const handleIframeError = () => {
    console.error('Failed to load Power BI iframe');
    setIsLoading(false);
  };
  
  return (
    <div className='gametime-container'>
      <div className='context-container'>
        {isLoading && (
          <div style={{ padding: '20px', textAlign: 'center', backgroundColor: '#f0f0f0' }}>
            Loading Power BI Report{uniqueId ? ` (Filtered by: ${uniqueId})` : ''}...
          </div>
        )}
        {embedUrl && (
          <iframe
            title='Power BI Report Dashboard'
            width='100%'
            height='620'
            src={embedUrl}
            frameBorder='0'
            allowFullScreen={true}
            style={{ border: 'none', minHeight: '620px', display: isLoading ? 'none' : 'block' }}
            onLoad={handleIframeLoad}
            onError={handleIframeError}
          />
        )}
        {!embedUrl && !isLoading && (
          <div style={{ padding: '20px', backgroundColor: '#f8d7da', border: '1px solid #f5c6cb', borderRadius: '4px', color: '#721c24' }}>
            <strong>Error:</strong> Invalid Power BI URL
          </div>
        )}
      </div>
    </div>
  );
};

const AnomalyDetails = () => {
  const templateRef = useRef(null);
  const params = useParams();
  const [collapse, setCollapse] = useState([] as any);
  const [modalCollapse, setModalCollapse] = useState([] as any);
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [rightSection, setRightSection] = useState(false);
  const [opportunityDetail, setOpportunityDetail] = useState(
    {} as IOpportunityDetailItemModel
  );
  const [action, setAction] = useState([]); // @ts-ignore
  const [activeAction, setActiveAction] = useState("none" as OppModalAction);
  const [insightId, setInsightId] = useState<any>(params.id);
  const currentOpportunity = useSelector(getCurentOpportunitiesSelector);
  const [opportunityDetailLoading, setOpportunityDetailLoading] =
    useState(true);
  const [opportunityDetailError, setOpportunityDetailError] = useState(false);
  const onBoardingApiData: any = useSelector(getOnBoardingAPIData);
  const [activityDetails, setActivityDetails] = useState([] as any);
  const [tableData, setTableData] = useState([] as any);
  const [enableRetryErr, setEnableRetryErr] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [opportunityCategory, setOpportunityCategory] = useState("");
  const [opportunityObjectName, setOpportunityObjectName] = useState("");
  const [opportunityStatus, setOpportunityStatus] = useState("");
  const [actionTrackingStatus, setActionTrackingStatus] = useState("");
  const [detailedAnomalyStatus, setDetailedAnomalyStatus] = useState("");
  const [insightStatus, setInsightStatus] = useState("");
  const [auditLatestStatus, setAuditLatestStatus] = useState("");
  const [businessLatestStatus, setBusinessLatestStatus] = useState("");
  const [domainName, setDomainName] = useState("projects");
  const [businessRejectedCount, setBusinessRejectedCount] = useState(-1);
  const [businessAcceptedCount, setBusinessAcceptedCount] = useState(-1);
  const [auditRejectCount, setAuditRejectCount] = useState(-1);
  const [auditAcceptCount, setAuditAcceptCount] = useState(-1);
  const [completeButton, setCompleteButton] = useState(false);
  const [showSummaryStatistics, toggleSummaryStatistics] = useState(false);
  const userOnboardData = useSelector(getOnBoardingAPIData);
  const [currentTab, setCurrentTab] = useState(0);
  const detailedView = useSelector(getDetailedView);
  const lastPageBeforeLandingDetailedPage = useSelector(
    getLastPageBeforeLandingDetailedPage
  );
  const [orphanStatus, setOrphanStatus] = useState(false);
  const [detailModal, setDetailModal] = useState(false);
  const [downloadModal, setDownloadModal] = useState(false);
  const [expandDetails, setExpandDetails] = useState(false);
  const [prevAnomalyId, setPrevAnomalyId] = useState<Array<number> | null>(
    null
  );

  const current_role = useSelector(getCurrentRole);
  const newInsightId = opportunityDetail?.new_insight_id || null;

  const fullOpportunityDetail = useMemo(() => {
    if (currentOpportunity&&currentOpportunity.status === 'finished') {
      return currentOpportunity?.data?.opportunity_detail?.[0] || {};
    } else return {};
  }, [currentOpportunity]);
  

  const navigate = useNavigate();
  const LOCATION = useLocation();
  // 'PUSH' means we arrived here from another in-app page, so browser-back is safe;
  // 'POP'/'REPLACE' (direct URL, deep link, SSO callback redirect) have no safe in-app entry to go back to.
  const navigationType = useNavigationType();

  const dispatch = useAppDispatch();
  const redirectionHeader = getMessage('app.anomalies.details.header');
  const anomalyDetailsHeader = getMessage('app.anomalydetails.tab.anomalydetails');
  const auditTrailHeader = getMessage('app.anomalydetails.tab.audittrail');
  const goBackBtn = getMessage('app.anomalydetails.footer.goback');
  const completeTaskBtn = getMessage('app.anomalydetails.footer.completeTask');
  const shareBtn = getMessage('app.anomalydetails.footer.share');
  const moreContextBtn = getMessage('app.anomalydetails.footer.context');
  const actionReqBtn = getMessage('app.anomalydetails.footer.actionreq');
  const noActionReqBtn = getMessage('app.anomalydetails.footer.noactionreq');
  const commentBtn = getMessage('app.anomalydetails.footer.comment');
  const auditRejectBtn = getMessage('app.anomalydetails.footer.auditreject');
  const auditAcceptBtn = getMessage('app.anomalydetails.footer.auditaccept');
  const businessRejectBtn = getMessage('app.anomalydetails.footer.businessreject');
  const businessAcceptBtn = getMessage('app.anomalydetails.footer.businessaccept');
  const reviewTaskBtn = getMessage('app.anomalydetails.footer.reviewtask');
  const reviewBtn = getMessage('app.anomalydetails.footer.review');
  const acknowledgedActionBtn = getMessage('app.anomalydetails.footer.ackaction');
  const reviewedBtn = getMessage('app.anomalydetails.footer.reviewed');
  const escalatedBtn = getMessage('app.anomalydetails.footer.escalated');
  const viewDetailsLink = getMessage('app.anomalydetails.po.viewdetails');
  const copyLineItemsLink = getMessage('app.anomalydetails.po.copyline');

  const onEscalateClick = () => {
    tagEvent("AnomalyIdClick", { AnomalyId: newInsightId });
    setInsightId(newInsightId);
    navigate(RouteConstants.ANOMALY_DETAILS_RELATIVE_PATH + `/${newInsightId}`);
  };

  useEffect(() => {
    let insightId: any = params.id;
    setInsightId(insightId);
    dispatch(setDetailedView("detailed_view"));
    dispatch(setCurrentInsightID(insightId));
    dispatch(getCurrentOpportunities())?.then((response: any) => {
      if (response.payload.opportunity_detail) {
        let prevAnomalyId =
          response.payload.opportunity_detail[0].previous_anomaly_id;
        const checkedPrevAnomalyId =
          Array.isArray(prevAnomalyId) && prevAnomalyId.length > 0
            ? prevAnomalyId
            : null;
        setPrevAnomalyId(checkedPrevAnomalyId);
        setRoleName(response.payload.opportunity_detail[0].role_name);
        setOpportunityCategory(
          response.payload.opportunity_detail[0]
            .insight_summary_insight_category
        );
        setOpportunityObjectName(
          response.payload.opportunity_detail[0].insight_summary_object_name
        );
        setOpportunityStatus(
          response.payload.opportunity_detail[0].insight_status
        );
        setActionTrackingStatus(
          response.payload.opportunity_detail[0].tracking_status
        );
        setDetailedAnomalyStatus(
          response.payload.opportunity_detail[0].card_display_status
        );
        setInsightStatus(response.payload.opportunity_detail[0].insight_status);
        setAuditLatestStatus(
          response.payload.opportunity_detail[0].audit_latest_status
        );
        setBusinessLatestStatus(
          response.payload.opportunity_detail[0].business_latest_status
        );
        setBusinessRejectedCount(
          response.payload.opportunity_detail[0].business_rejected_count
        );
        setBusinessAcceptedCount(
          response.payload.opportunity_detail[0].business_accepted_count
        );
        setAuditRejectCount(
          response.payload.opportunity_detail[0].audit_rejected_count
        );
        setAuditAcceptCount(
          response.payload.opportunity_detail[0].audit_accepted_count
        );
        setCompleteButton(
          response.payload.opportunity_detail[0].show_complete_button
        );
        setDomainName(
          response.payload.opportunity_detail[0].insight_module_name
        );
      }
    });

    getOpportunitiesDetail(insightId, current_role)
      .then((response: any) => {
        setOpportunityDetail(response);
        setAction(response?.action_details || []);
        // let acceptedOrgAction: any = [];
        // if (response?.action_details) {
        //   acceptedOrgAction = response.action_details.filter((data: any) => data.user_response == 'accept-org-user' || data.user_response == 'reject-org-user');
        // }
        setOpportunityDetailLoading(false);
        converTable(response);
        const collapseDetail = response?.detail?.filter(
          (data: any) => data.section_type === "lineitem"
        ) || []
        setCollapse(collapseDetail);
        setModalCollapse(collapseDetail);
        setOpportunityDetailError(false);
        if (response?.is_orphaned === "Y") setOrphanStatus(true);
        else setOrphanStatus(false);
      })
      .catch(() => {
        setOpportunityDetailError(true);
        setOpportunityDetailLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current_role, params.id]);

  useEffect(() => {
    setLoader(true);
    let id: any = params.id;
    setOpportunityDetailLoading(true);
    setOpportunityDetailError(false);
    if (
      onBoardingApiData?.roles[0] === "insight.org_user" ||
      current_role === USER_ROLE.ORG_USER
    ) {
      getUserAction(id)
        .then((response) => {
          let result: any = response;
          setActivityDetails(result.activity);
        })
        .catch(() => {
          console.log("Error");
        });
    }
    getOpportunitiesDetail(id, current_role)
      .then((response: any) => {
        setLoader(false);
        setOpportunityDetail(response);
        setAction(response.action_details);
        let acceptedOrgAction: any = [];
        if (response&& response.action_details) {
          acceptedOrgAction = response.action_details.filter(
            (data: any) =>
              data.user_response == "accept-org-user" ||
              data.user_response == "reject-org-user"
          );
        }
        // if(acceptedOrgAction.length>0)
        // {
        //     setCardOpenStatus(false);
        // }
        setOpportunityDetailLoading(false);
        converTable(response);
        const values = response.detail!==null ? response.detail.filter((data: any) => data.section_type === 'lineitem') : [];        setCollapse(values);
        setModalCollapse(values);
      })
      .catch(() => {
        setLoader(false);
        setOpportunityDetailError(true);
        setOpportunityDetailLoading(false);
      });
  }, [params]);

  const getToolTip = (label: string, sectionType: string) => {
    let dataDetails = opportunityDetail.detail?.find((data: any) => data.section_type === sectionType);
    if (dataDetails) {
      const sectionDetails = dataDetails.section_detail;
      const toolTip = sectionDetails?.description ? sectionDetails.description[label] : null;
      return toolTip;
    }
  }

  let converTable = (details: any) => {
    if (!details) {
      setTableData([]);
      return;
    }
    let dataDetails = details?.detail?.filter((data: any) => data.section_type === 'header') || [];
    if (dataDetails.length > 0) {
      dataDetails = dataDetails[0].section_detail;
      let labels = Object.keys(dataDetails.labels).map(
        (key) => dataDetails.labels[key]
      );
      let usdPattern = /(usd)/i;
      const usdArr = labels
        .filter((x) => usdPattern.test(x))
        .map((i) => labels.indexOf(i));
      let tableData = [labels];
      for (const element of dataDetails.values) {
        let data1 = Object.keys(element).map((key) => element[key]);
        usdArr.forEach((n) => {
          if (!isNaN(data1[n])) {
            data1[n] = new Intl.NumberFormat().format(data1[n]);
          }
          return data1;
        });
        tableData.push(data1);
      }
      let transposeTableData = tableData[0].map((_, colIndex) =>
        tableData.map((row) => row[colIndex])
      );
      setTableData(transposeTableData);
    } else {
      setTableData([]);
    }
  };

  const handleGoBack = () => {
    dispatch(setPaginationCurrentPage(lastPageBeforeLandingDetailedPage));
    if (detailedView.length > 0 && navigationType === "PUSH") {
      navigate(-1);
    } else {
      navigate(RouteConstants.DASHBOARD);
    }
  };

  const closeRightRail = () => {
    setRightSection(false);
    setErrorMessage("");
  };

  //Handle Active action - Right getallOpportunitiesOverlay
  const getPopupContent = () => {
    let roleName = "";
    let opportunityCategory = "";
    let opportunityObjectName = "";
    let opportunityStatus = "";
    let actionTrackingStatus = "";
    let auditLatestStatus = "";
    let businessLatestStatus = "";
    if (currentOpportunity?.status == "finished") {
      let currentOpprtunityDetails: any = { ...currentOpportunity };
      if (
        currentOpprtunityDetails &&
        currentOpprtunityDetails?.data !== 0 &&
        currentOpprtunityDetails?.data?.opportunity_detail?.length === 1
      ) {
        roleName =
          currentOpprtunityDetails.data.opportunity_detail[0].role_name;
        opportunityStatus =
          currentOpprtunityDetails.data.opportunity_detail[0].insight_status;
        actionTrackingStatus =
          currentOpprtunityDetails.data.opportunity_detail[0].tracking_status;
        auditLatestStatus =
          currentOpprtunityDetails.data.opportunity_detail[0]
            .audit_latest_status;
        businessLatestStatus =
          currentOpprtunityDetails.data.opportunity_detail[0]
            .business_latest_status;
        opportunityCategory =
          currentOpprtunityDetails.data.opportunity_detail[0]
            .insight_summary_insight_category;
        opportunityObjectName =
          currentOpprtunityDetails.data.opportunity_detail[0]
            .insight_summary_object_name;
      }
    }
    if (
      activeAction === "more-context" ||
      activeAction === "share" ||
      activeAction === "share-via-email"
    ) {
      return (
        <GetMoreContext
          anomaly_id={insightId}
          onClose={closeRightRail}
          opportunityId={insightId}
          kpiId={opportunityDetail.kpi_id ?? 1}
          sendingMailToatser={sendingMail}
          textAreaTitle="Please enter comments."
          title={
            roleName === USER_ROLE.POWER_USER ||
              roleName === USER_ROLE.DOMAIN_FOCAL
              ? REQUEST_INPUT_TITLE
              : MORE_CONTEXT_POPUP_TITLE
          }
          activeAction={activeAction}
        />
      );
    } else if (activeAction === "reject") {
      return (
        <RejectPopup
          role_name={roleName}
          insightId={insightId}
          onClose={closeRightRail}
          opportunityId={insightId}
          title={REJECT_POPUP_TITLE}
          kpiId={opportunityDetail.kpi_id ?? 1}
          activityDetails={activityDetails}
          textAreaTitle="Please enter remarks."
          opportunityCategory={opportunityCategory}
          insightSummaryDisplayCategory={opportunityDetail.insight_summary_display_category}
        // closeAction={closeActionPopup}
        />
      );
    }
    

    else if (activeAction === 'reviewer-checklist') {
      return (
        <ReviewerCheckList
          role_name={roleName}
          insightId={insightId}
          onClose={closeRightRail}
          opportunityId={insightId}
          title={ACCEPT_POPUP_TITLE}
          errorMessage={errorMessage}
          kpiId={opportunityDetail.kpi_id ?? 1}
          activityDetails={activityDetails}
          sendUserResponse={sendUserResponse}
          textAreaTitle="Please enter remarks."
          orguserId={opportunityDetail.orguser_id}
          anomalyId={opportunityDetail.insight_id.toString()}
          insightSummaryDisplayCategory={opportunityDetail.insight_summary_display_category}
          modelId={opportunityDetail.model_id}
        // closeAction={closeActionPopup}
        />
      );
    }
    else if (activeAction === "accept") {
      return (
        <AcceptPopup
          role_name={roleName}
          insightId={insightId}
          onClose={closeRightRail}
          opportunityId={insightId}
          title={ACCEPT_POPUP_TITLE}
          errorMessage={errorMessage}
          kpiId={opportunityDetail.kpi_id ?? 1}
          activityDetails={activityDetails}
          sendUserResponse={sendUserResponse}
          textAreaTitle="Please enter remarks."
          orguserId={opportunityDetail.orguser_id}
          anomalyId={opportunityDetail.insight_id.toString()}
          insightSummaryDisplayCategory={opportunityDetail.insight_summary_display_category}
          modelId={opportunityDetail.model_id}
        // closeAction={closeActionPopup}
        />
      );
    } else if (activeAction === "tracking-submit") {
      return (
        <CompleteTaskActionPopup
          onClose={closeRightRail}
          sendUserResponse={sendUserResponse}
          opportunityId={insightId}
          kpiId={opportunityDetail.kpi_id ?? 1}
          title="Complete Task"
          textAreaTitle="Please enter comments."
          anomaly_id={opportunityDetail.insight_id.toString()}
          orgOwnerId={opportunityDetail.orguser_id}
          sendingMailToatser={sendingMail}
          insightSummaryDisplayCategory={opportunityDetail.insight_summary_display_category}
          modelId={opportunityDetail.model_id}
        />
      );
    } else if (activeAction === "notes") {
      return (
        <>
          <Notes
            role_name={roleName}
            onClose={closeRightRail}
            opportunityId={insightId}
            opportunityStatus={opportunityStatus}
            opportunityObjectName={opportunityObjectName}
          />
        </>
      );
    } else if (activeAction === "acknowledge") {
      return (
        <Acknowledge
          role_name={roleName}
          onClose={closeRightRail}
          opportunityId={insightId}
          sendUserResponse={acknowledgeAndActioning}
          kpiId={opportunityDetail.kpi_id ?? 1}
          orguserId={opportunityDetail.orguser_id}
          anomalyId={opportunityDetail.insight_id.toString()}
        />
      );
    } else if (activeAction === "review-task") {
      return (
        // <ReviewTask  onClose={closeRightRail} opportunityId={insightId} opportunityStatus={props.opportunityStatus} opportunityObjectName={props.opportunityObjectName} role_name={roleName} trackingStatus={props.actionTrackingStatus} closeReview={closeReviewAction} sendingMailToatser={sendingMail} />
        <ReviewCompletion
          onClose={closeRightRail}
          opportunityId={insightId}
          role_name={roleName}
          trackingStatus={actionTrackingStatus}
          // closeReview={closeReviewAction}
          sendingMailToatser={sendingMail}
          insightSummaryDisplayCategory={opportunityDetail.insight_summary_display_category}
          modelId={opportunityDetail.model_id}
        />
      );
    } else if (
      activeAction === AUDIT_RESPONSE_STATUS.REJECT ||
      activeAction === AUDIT_RESPONSE_STATUS.ACCEPT ||
      activeAction === "business-accept" ||
      activeAction === "business-reject"
    ) {
      return (
        <AuditReject
          role_name={roleName}
          onClose={closeRightRail}
          auditType={activeAction}
          opportunityId={insightId}
          sendingMailToatser={sendingMail}
          kpiId={opportunityDetail.kpi_id ?? 1}
          insightStatus={opportunityStatus}
          sendUserResponse={sendUserResponse}
          orgUserId={opportunityDetail.orguser_id}
          anomaly_id={opportunityDetail.insight_id}
          reviewerId={opportunityDetail.reviewer_id}
          auditSubmitDisable={
            getAuditAcceptButton(
              roleName,
              opportunityStatus,
              auditLatestStatus,
              businessLatestStatus,
              detailedAnomalyStatus
            ) === "disable"
          }
          textAreaTitle={
            activeAction === AUDIT_RESPONSE_STATUS.REJECT
              ? "This is mandatory field. Please state the reason for sending anomaly back."
              : "optional comments"
          }
          title={
            roleName === USER_ROLE.DOMAIN_FOCAL
              ? activeAction === "business-reject"
                ? "Business Reject"
                : "Business Accept"
              : activeAction === AUDIT_RESPONSE_STATUS.REJECT
                ? "Audit Reject"
                : "Audit Accept"
          }
        />
      );
    } else {
      return <></>;
    }
  };

  //Handled style corresponds to anomaly detail page
  /*useEffect(() => {
      // document.body.style.overflow = "hidden";
      let element:any = document.getElementById("footerDiv");
      element.classList.add("detail-view-footer");
      return () => {
          // document.body.style.overflow = "auto"
          let element:any = document.getElementById("footerDiv");
          element.classList.remove("detail-view-footer");
      }
  }, [])*/

  type MailToastType = "loading" | "failure" | "success";

  const sendingMail = (type: MailToastType, message: string) => {
    if (type === "loading") {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-info"
            root="common"
            size="large"
            color="#007ad9"
            className="status-indicator-icon"
          />{" "}
          {message}
        </div>
      ); // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: "bottom-right",
        className: "fi-toast--snackbar",
        bodyClassName: "fi-toast__body--snackbar",
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === "success") {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-check"
            root="common"
            size="large"
            color="#279d2b"
            className="status-indicator-icon"
          />
          {message}
        </div>
      ); // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: "bottom-right",
        className: "fi-toast--snackbar",
        bodyClassName: "fi-toast__body--snackbar",
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === "failure") {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-stop"
            root="common"
            size="large"
            color="#BE271C"
            className="status-indicator-icon"
          />
          <p>{message}</p>
        </div>
      ); // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: "bottom-right",
        className: "fi-toast--snackbar",
        bodyClassName: "fi-toast__body--snackbar",
        transition: Zoom,
        closeOnClick: true,
      });
    }
  };

  type ToastType =
    | "accept"
    | "reject"
    | "realize"
    | "claim-ownerShip"
    | "more-context"
    | "notes";

  const showActionToast = (toastContent: ToastContent, type: ToastType) => {
    if (type === "reject" || type === "realize") {
      toast(toastContent, {
        position: "bottom-right",
        className: "fi-toast--snackbar",
        bodyClassName: "fi-toast__body--snackbar",
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === "accept") {
      toast(toastContent, {
        className: "fi-toast--accept",
        bodyClassName: "fi-toast__body--accept",
        transition: AcceptToastTransition,
        closeOnClick: true,
      });
    } else if (type === "more-context") {
      toast(toastContent, {
        position: "bottom-right",
        className: "fi-toast--snackbar",
        bodyClassName: "fi-toast__body--snackbar",
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === "claim-ownerShip") {
      toast(toastContent, {
        position: "bottom-right",
        className: "fi-toast--snackbar",
        bodyClassName: "fi-toast__body--snackbar",
        transition: Zoom,
        closeOnClick: true,
      });
    }
  };
  const acknowledgeAndActioning = (data: any) => {
    sendUserResponse({ ...data, type: TRACKING_COMPLETE });
  }


  const sendUserResponse = (
    data: IUserResponseModel,
    emailList: string[] = []
  ) => {
    setErrorMessage("");
    let roleName = "";
    let opportunityId;
    if (currentOpportunity.status == "finished") {
      let currentOpprtunityDetails: any = currentOpportunity;
      if (currentOpprtunityDetails.data.opportunity_detail.length === 1) {
        roleName =
          currentOpprtunityDetails.data.opportunity_detail[0].role_name;
        opportunityId =
          currentOpprtunityDetails.data.opportunity_detail[0].insight_id;
      }
    }
    if (emailList.length > 0 && roleName === USER_ROLE.ORG_USER) {
      sendingMail("loading", "Sending Mail...");
      dispatch(updateTrackingOpportunity(opportunityId, data))
        .then((response: any) => {
          //   setIsButtonLoading(false);
          response.data.mail_status === MAIL_SENT
            ? sendingMail("success", `${response.data.mail_status}`)
            : sendingMail("failure", `${response.data.mail_status}`);
          showActionToast(
            <AcceptOppToast supplierName={opportunityDetail.insight_id} />,
            "accept"
          );
          navigate(RouteConstants.ANOMALY_ABSOLUTE_PATH);
        })
        .catch((err: any) => {
          setErrorMessage(err.response.data.message);

          //   setIsButtonLoading(false);
          //   setEnableRetryErr(true);
          //   setBtnText('Retry');
        });
    } else {
      // navigate(RouteConstants.DASHBOARD)
      dispatch(updateOpportunity(opportunityDetail.insight_id, data))
        .then((response: any) => {
          if (data.user_response === "accept") {
            tagEvent(TAG_EVENT_CONST.review, { AnomalyId: opportunityDetail.insight_id, AcceptCount: 'EventCount' });
            // setIsButtonLoading(false);
            response.data.mail_status === MAIL_SENT
              ? sendingMail("success", `${response.data.mail_status}`)
              : sendingMail("failure", `${response.data.mail_status}`);
            showActionToast(
              <AcceptOppToast supplierName={opportunityDetail.insight_id} />,
              "accept"
            );
          }
          navigate(RouteConstants.ANOMALY_ABSOLUTE_PATH);
          //   props.onClose();
          // no toast for reopen
        })
        .catch((err: any) => {
          setErrorMessage("Something went wrong.Please try again");
          //   setIsButtonLoading(false);
          //   setEnableRetryErr(true);
          //   setBtnText('Retry');
        });
    }
  };
  const isUSDValue = (value: string): boolean => {
    let usdPattern = /(usd)/i;
    if (usdPattern.test(value)) {
      return true;
    }
    return false;
  };

  const valueRenderer = (cellData: any) => {
    return <>{cellData.value}</>;
  };

  const usdRenderer = (cellData: any) => {
    if (!isNaN(cellData.value)) {
      let data = new Intl.NumberFormat().format(cellData.value);
      return <>{data}</>;
    } else {
      return <>{cellData.value}</>;
    }
  };

  const handleGeneratePdf = async () => {
    const data: any = document.getElementById(`insight-${insightId}`);
    window.scrollTo(0, 0);
    const height = data.scrollHeight || 0;
    const width =  document.body.clientWidth || 0;
    html2canvas(data, {
      height: height,
      windowHeight: height,
      width: width,
      windowWidth: width,
      logging: false
    }).then(canvas => {
      var imgData = canvas.toDataURL("image/jpeg");
      const imgWidth = 180;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;
      heightLeft -= pageHeight;
      const doc = new jsPDF('p', 'mm');
      doc.addImage(imgData, 'JPEG', 15, position, imgWidth, imgHeight);
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, 'JPEG', 15, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      const pdfFile = insightId + ".pdf";
      doc.save(pdfFile);
      toast(<Snackbar toastMessage="Dowloaded Successfully" />, {
        position: "bottom-right",
        className: "fi-toast--snackbar",
        bodyClassName: "fi-toast__body--snackbar",
        transition: Zoom,
        closeOnClick: true,
      });
      setDownloadModal(false);
    });
  };

  const onDownloadClose = () => {
    setDownloadModal(false);
    setExpandDetails(false);
  }

  const anomalyContent = (downloadAnomalyDetails: boolean) => {

    const RenderTable: FC<{ collapse: IOpportunityOrderDetailsModel[], openInitial?: boolean, expand?: boolean }> = memo(({
      collapse, openInitial, expand = false,
    }) => {
      const [openCollapse, setOpenCollapse] = useState('1');
      const [collapseHeader, setCollapseHeader] = useState(false);
      const [expandData, setExpandData] = useState(expand);
      const handleClick = (section_label: string) => {
        if (expandData) {
          setOpenCollapse('-1');
          setCollapseHeader(false);
          setExpandData(false);
        } else if (section_label === openCollapse) {
          setOpenCollapse('-1');
          setCollapseHeader(false);
        } else if (section_label !== openCollapse) {
          setOpenCollapse(section_label);
          setCollapseHeader(true);
        }
        document.getElementById('scroll')?.scrollIntoView();
      };

      
      useEffect(() => {
        if (openInitial && collapse?.length > 0) {
          const data = collapse[0]?.section_label || '-1';
          setOpenCollapse(data)
        }
      }, [collapse, openInitial])
      return (
        <>
          {(collapse || []).map((item: IOpportunityOrderDetailsModel) => {
            let isOpen;
            isOpen = openCollapse === item.section_label || domainName === PROJECT_DOMAIN;
            return (
              <Collapsible
                key={item.section_label}
                title={item.section_label}
                showModal={isOpen || expandData}
                setshowModal={() => handleClick(item.section_label)}>
                <div className='oppModal__collapseContent' id='scroll'>
                  {Object.entries(item.section_detail).length > 0 ? (
                    <DataTable
                      resizableColumns={false}
                      data={item.section_detail.values}
                      scrollable={true}>
                      {Object.entries(item.section_detail.labels).map(
                        ([key, value], index) => {
                          // @ts-ignore
                          return (
                            <DataTable.Column
                              className='oppModal__collapseContent--data'
                              key={key}
                              initialWidth='160px'
                              field={`value${index + 1}`}
                              align={'left'}
                              header={
                                <Tooltip
                                  className='oppModal__tooltip'
                                  content={value}
                                  element={
                                    <div className='elem_title'>{value}</div>
                                  }
                                  position='bottom right'
                                  event='hover'
                                  hoverable={true}
                                />
                              }
                              sortable={true}
                              renderer={
                                isUSDValue(value) ? usdRenderer : valueRenderer
                              }
                            />
                          );
                        }
                      )}
                    </DataTable>
                  ) : (
                    <div className='oppModal__collapse--nocontent'>
                      No Records Found
                    </div>
                  )}
                </div>
              </Collapsible>
            );
          })}
        </>
      );
    });

    return (
      <>
        <div className="content-section-tab1" id="content-section-tab1">
          {opportunityDetail && <DominoTracker anomaly={opportunityDetail} fullOpportunityDetail={fullOpportunityDetail}/> }
          {!opportunityDetailLoading &&
            !opportunityDetailError &&
            opportunityDetail && (
              <AnomalyBelt opportunityDetail={opportunityDetail} />
            )}

          {tableData.length > 0 ? (
            <>
              <div className="anomaly__header">
                {opportunityDetail && opportunityDetail.insight_summary_header_title}
              </div>
              <div className="anomaly__table__div">
                <div className="anomaly__anomalydiv">
                  <table className="anomaly__table">
                    <tbody className="anomaly__body">
                      {tableData.map((item: any, index: any) => (
                        <tr className="anomaly__column__tr">
                          {item.map((col: any) => (
                            <td className="anomaly__column__td">
                              {getToolTip(col, 'header') ? <Tooltip
                                content={getToolTip(col, 'header')}
                                element={
                                  <p>{col ? col : '-'}</p>
                                }
                                position="top left"
                                event="hover"
                                hoverable={true}
                              />
                                : <> {col ? col : '-'}</>}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          {collapse.length > 0 ? (
            <>
              <div className="anomaly__header">
                <div>
                  {opportunityDetail.insight_summary_lineitem_title}
                  {domainName !== PROJECT_DOMAIN ? `(` + opportunityDetail.insight_summary_object_name2 + `)` : null}
                </div>
                <div className="anomaly__header__action">
                  {downloadAnomalyDetails === true ? (<FontIcon className="action-btn" iconName="fa-expand" onClick={() => setExpandDetails(current => !current)}>
                    {expandDetails ? "Collapse" : "Expand"} </FontIcon>) : null}
                  <FontIcon className="action-btn" iconName="fa-eye" onClick={() => setDetailModal(true)}>
                    {viewDetailsLink}
                  </FontIcon>
                  {domainName !== PROJECT_DOMAIN ? <FontIcon className="action-btn" iconName="fa-clone" onClick={copyPoNumber}>
                    {copyLineItemsLink}
                  </FontIcon> : null}
                </div>
              </div>
              <div className={downloadAnomalyDetails === true ? "oppModal__collapse-lineItem--header--modal" : "oppModal__collapse-lineItem--header"}>
                <RenderTable collapse={collapse} expand={expandDetails} />
              </div>
            </>
          ) : (
            ""
          )}
        {/* Conditional rendering based on category */}
        {opportunityDetail && (
          (() => {
            const isGandHTrends = opportunityDetail.insight_summary_display_category === "G&H Trends";
            const isGiftsAndHospitality = opportunityDetail.insight_summary_insight_category === "Gifts and Hospitality Risk-Based Anomalies";
            const isCustomerRiskAnomaly = opportunityDetail.insight_summary_insight_category === "Customer Risk-Based Anomaly";
            const isPoCutAfterInvoice = opportunityDetail.insight_summary_insight_category === "PO Cut After Invoice"||  opportunityDetail.insight_summary_display_category === "PO Cut After Invoice";
            const isUI5Alert = opportunityDetail.insight_summary_display_category === "UI 5";
            const shouldUsePowerBI = isGiftsAndHospitality || isCustomerRiskAnomaly || isPoCutAfterInvoice;

            if ((isUI5Alert || isGandHTrends) && opportunityDetail.tableau_link) {
              return (
                <div className='gametime-container'>
                  <div className='context-container'>
                    <iframe
                      title={isGandHTrends ? 'gnh-alert-released' : 'ui5-alert'}
                      className='context-frame'
                      src={opportunityDetail.tableau_link}
                      frameBorder='0'
                      allowFullScreen={true}
                    />
                  </div>
                </div>
              );
            }
            
            
            // Extract unique identifier from object name
            // For all Power BI categories (Customer Risk, PO Cut), use the full object name
            const uniqueId = opportunityDetail.insight_summary_object_name || '';
            
            // Check for PNG files first
            if (opportunityDetail.insight_summary_object_name && 
                opportunityDetail?.tableau_link && 
                opportunityDetail?.tableau_link.includes(".png")) {
              return (
                <ContextPDFContent 
                  insight_id={opportunityDetail.insight_id} 
                  file_name={`${opportunityDetail.insight_summary_object_name}.png`} 
                  stored_file_name={`${opportunityDetail.insight_summary_object_name}.png`} 
                  type={'image/png'}
                />
              );
            }

            if (isGandHTrends) {
              return null;
            }
            
            // Use Power BI for specific categories
            if (shouldUsePowerBI) {
              // Different report IDs for each category
              let reportId;
              let filterType: 'gnh' | 'diversion' | 'pocut' | 'tracking304';
              
              if (isGiftsAndHospitality) {
                reportId = '2f6d49f1-bdc9-45fd-a229-f2764ed5a5c4'; // G&H Report
                filterType = 'gnh';
              } else if (isCustomerRiskAnomaly) {
                reportId = '43aac326-4849-4f53-9daf-26689fa7351e'; // Customer Risk Report
                filterType = 'diversion';
              } else if (isPoCutAfterInvoice) {
                reportId = '0fb6c350-e24c-4aba-84a2-ccbe240b09e0'; // PO Cut Report
                filterType = 'pocut';
              } else {
                reportId = '2f6d49f1-bdc9-45fd-a229-f2764ed5a5c4'; // Default to G&H
                filterType = 'gnh';
              }
              
              const basePowerBIUrl = `https://app.powerbi.com/reportEmbed?reportId=${reportId}&autoAuth=true&ctid=96ece526-9c7d-48b0-8daf-8b93c90a5d18`;
              console.log("Embedding Power BI report with URL:", basePowerBIUrl);
              return (
                <div>
                  {
                    console.log("Rendering PowerBIContent with uniqueId:", uniqueId, "and filterType:", filterType)


                  }

                      <PowerBIContent 
                  powerbi_link={basePowerBIUrl}
                      uniqueId={isGiftsAndHospitality || isCustomerRiskAnomaly || isPoCutAfterInvoice ? uniqueId : undefined}
                  filterType={filterType}
                />

                  </div>
            
              );
            }
            
            // Use Tableau for other categories
            if (opportunityDetail?.tableau_link) {
              return (
                <ContextContent 
                  tableau_link={opportunityDetail?.tableau_link}
                />
              );
            }
            
            return null;
          })()
        )}
        </div>
        <Modal
          size={'large'}
          closeIcon
          open={detailModal}
          onClose={() => setDetailModal(false)}
          className='modal-fi detail-table-modal'
        >
          <Modal.Header>
            {opportunityDetail.insight_summary_lineitem_title}(
            {opportunityDetail.insight_summary_object_name2})
            {domainName !== PROJECT_DOMAIN &&
              <FontIcon className="action-btn" iconName="fa-clone" onClick={copyPoNumber}>
                Copy Line Items
              </FontIcon>
            }
          </Modal.Header>
          <Modal.Content>
            <RenderTable collapse={collapse} openInitial />
          </Modal.Content>
        </Modal>
      </>
    );
  };

  const auditTrailContent = () => {
    return (
      <>
        <div className="content-section-tab2" id="content-section-tab2">
          <AnomalyBelt opportunityDetail={opportunityDetail} />
          <div className="action-card-div">
            <Card className="action-card">
              <Card.Content>
                <AuditTrailActivity
                  onClose={closeRightRail}
                  opportunityId={insightId}
                  opportunityStatus={opportunityStatus}
                  opportunityObjectName={opportunityObjectName}
                  role_name={roleName}
                />
              </Card.Content>
            </Card>
          </div>
        </div>
      </>
    );
  };



  const copyPoNumber = () => {
    let poNumbers: any = opportunityDetail.detail.map((lineitem: any) => {
      return lineitem.section_label.replace(/[^0-9]/g, "");
    });
    poNumbers.pop(poNumbers.length);
    var text = poNumbers.join("\n");

    navigator.clipboard.writeText(text).then(
      function () {
        toast(<Snackbar toastMessage={PO_NUMBERS_COPIED} />, {
          position: "bottom-right",
          className: "fi-toast--snackbar",
          bodyClassName: "fi-toast__body--snackbar",
          transition: Zoom,
          closeOnClick: true,
        });
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      }
    );
  };
  let contentWidth = rightSection ? "65%" : "100%";

  const renderPopUpHeader = () => {
    return (
      <>
        <div className="header-title">
          <div>{getPopUpHeaderTitle(activeAction)}</div>
          {activeAction === "reject" && (
            <div className="reject-notes notransform">{`${REJECT_NOTES}`}</div>
          )}
        </div>
        <FontIcon className="close" iconName="fa-close" iconSize="large" onClick={() => setRightSection(false)} />
      </>
    );
  };
  const handleShare = () => {
    setActiveAction("share-via-email");
    setRightSection(true);
  };

  const powerUserOrLeaderShip =
    userOnboardData &&
      userOnboardData.roles?.length &&
      (userOnboardData?.roles[0] == USER_ROLE.POWER_USER ||
        userOnboardData?.roles[0] == USER_ROLE.LEADERSHIP_USER)
      ? true
      : false;

  return (
    <>
      <Loader
        loading={loader}
        text="Loading..."
        className="gird-loader"
      ></Loader>
      <div className={`anomaly anomaly-section ${!loader ? 'page-fadeIn-effect' : ''}`}>
        <div style={{ width: `${contentWidth}` }}>
          <div className="content-section-header">
            <FontIcon iconName="fa-angle-left" iconSize="medium" onClick={handleGoBack}>{redirectionHeader} {insightId}</FontIcon>
            <div>
              <div className="review_summary-detailed-view">
                {powerUserOrLeaderShip && current_role != USER_ROLE.VIEWER && (
                  <ReviewButton
                    showSummaryStatistics={showSummaryStatistics}
                    toggleSummaryStatistics={toggleSummaryStatistics}
                    addExtraWidth
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="anomaly-content">
          <div className="left-section" style={{ width: `${contentWidth}` }}>
            <div className="tab-conatiner">
              <div className="tab-conatiner-left">
                <div
                  className={
                    currentTab === 0 ? "active-i item-tab details" : "item-tab details"
                  }
                  onClick={() => setCurrentTab(0)}
                >
                  {anomalyDetailsHeader}
                </div>

                <div
                  className={
                    currentTab === 1 ? "active-i item-tab audit" : "item-tab audit"
                  }
                  onClick={() => setCurrentTab(1)}
                >
                  {auditTrailHeader}
                </div>
              </div>
              <div className="tab-conatiner-right">
                <FontIcon className="share-icon" iconName="fa-download" iconSize="medium" onClick={() => setDownloadModal(true)} />
                {!orphanStatus && (
                  <FontIcon className="share-icon" iconName="fa-share-alt" iconSize="medium" onClick={handleShare} />

                )}
              </div>
            </div>
            {currentTab === 0 ? anomalyContent(false) : auditTrailContent()}

          </div>
          {rightSection && (
            <div className="right-section">
              <div className="right-header">{renderPopUpHeader()}</div>
              <div className="content-class">{getPopupContent()}</div>
              {activeAction === "notes" &&
                <NotesFooter
                  onClose={closeRightRail}
                  opportunityId={insightId}
                  opportunityObjectName={opportunityObjectName} />}
            </div>
          )}
        </div>
      </div>

      <div
        className={
          rightSection === true
            ? "filter__content--apply-detail  unclickable"
            : "filter__content--apply-detail"
        }
      >
        <div className="button-footer-left ">
          <Button
            type="secondary"
            size="small"
            textTransform={false}
            className={`back-button custom-btn ${rightSection && "disabled-mode"}`}
            onClick={() => !rightSection && handleGoBack()}
          >
            {goBackBtn}
          </Button>
        </div>

        {getRightFooter({ prevAnomalyId, roleName, domainName }) && (
          <div className="button-footer-right">
            {(roleName === USER_ROLE.VIEWER
            //  ||              roleName === USER_ROLE.REVIEWER
            ) &&
              completeButton && (
                <Button
                  className={`button--secondary button-space ${rightSection && "disable"
                    }`}
                  type="secondary"
                  iconPosition="right"
                  size="small"
                  content={completeTaskBtn}
                  data-testid="comment-btn"
                  disabled={rightSection ? true : false}
                  onClick={() => {
                    setActiveAction("tracking-submit");
                    setRightSection(true);
                  }}
                />
              )}
            {getMoreContextButtonStatus(
              roleName,
              opportunityStatus,
              detailedAnomalyStatus,
              { domainName, prevAnomalyId }
            ) &&
              !orphanStatus && (
                <Button
                  className={`button--secondary button-space ${rightSection && "disable"
                    }`}
                  size="small"
                  type="secondary"
                  data-testid="get-context"
                  disabled={rightSection ? true : false}
                  onClick={() => {
                    roleName === USER_ROLE.POWER_USER ||
                      roleName === USER_ROLE.DOMAIN_FOCAL ||
                      roleName === USER_ROLE.ADMIN_USER
                      ? setActiveAction("share")
                      : setActiveAction("more-context");
                    setRightSection(true);
                  }}
                  content={
                    roleName === USER_ROLE.POWER_USER ||
                      roleName === USER_ROLE.DOMAIN_FOCAL ||
                      roleName === USER_ROLE.ADMIN_USER
                      ? shareBtn
                      : moreContextBtn
                  }
                />
              )}
            {(getAuditAcceptButton(
              roleName,
              insightStatus,
              auditLatestStatus,
              businessLatestStatus,
              detailedAnomalyStatus
            ) === "visible" ||
              getAuditAcceptButton(
                roleName,
                insightStatus,
                auditLatestStatus,
                businessLatestStatus,
                detailedAnomalyStatus
              ) === "disable") && (
                <Button
                  className={`button--secondary button-space ${rightSection && "disable"
                    }`}
                  size="small"
                  type="secondary"
                  content={
                    roleName === USER_ROLE.DOMAIN_FOCAL
                      ? businessRejectedCount == null ||
                        businessRejectedCount == 0
                        ? businessRejectBtn
                        : `${businessRejectBtn}(${businessRejectedCount})`
                      : auditRejectCount == null || auditRejectCount == 0
                        ? auditRejectBtn
                        : `${auditRejectBtn}(${auditRejectCount})`
                  }
                  data-testid="comment-btn"
                  disabled={rightSection ? true : false}
                  onClick={() => {
                    roleName === USER_ROLE.DOMAIN_FOCAL
                      ? setActiveAction("business-reject")
                      : setActiveAction("audit-reject");
                    setRightSection(true);
                  }}
                />
              )}

            {(getAuditAcceptButton(
              roleName,
              insightStatus,
              auditLatestStatus,
              businessLatestStatus,
              detailedAnomalyStatus
            ) === "visible" ||
              getAuditAcceptButton(
                roleName,
                insightStatus,
                auditLatestStatus,
                businessLatestStatus,
                detailedAnomalyStatus
              ) === "disable") && (
                <Button
                  className={`button--secondary button-space ${rightSection && "disable"
                    }`}
                  size="small"
                  type="secondary"
                  content={
                    roleName === USER_ROLE.DOMAIN_FOCAL
                      ? businessAcceptedCount == null ||
                        businessAcceptedCount == 0
                        ? businessAcceptBtn
                        : `${businessAcceptBtn}(${businessAcceptedCount})`
                      : auditAcceptCount == null || auditAcceptCount == 0
                        ? auditAcceptBtn
                        : `${auditAcceptBtn}(${auditAcceptCount})`
                  }
                  data-testid="comment-btn"
                  disabled={rightSection ? true : false}
                  onClick={() => {
                    roleName === USER_ROLE.DOMAIN_FOCAL
                      ? setActiveAction("business-accept")
                      : setActiveAction("audit-accept");
                    setRightSection(true);
                  }}
                />
              )}

            {getCommentButton({
              roleName,
              domainName,
              detailedAnomalyStatus,
              prevAnomalyId,
            }) && (
                <Button
                  className={`${roleName === ROLE_NAME.VIEWER
                    ? "button--primary"
                    : "button--secondary"
                    } button-space ${rightSection && "disable"}`}
                  iconPosition="right"
                  size="small"
                  type={roleName === ROLE_NAME.VIEWER ? "primary" : "secondary"}
                  content={commentBtn}
                  data-testid="comment-btn"
                  disabled={rightSection ? true : false}
                  onClick={() => {
                    setActiveAction("notes");
                    setRightSection(true);
                  }}
                />
              )}

            {/* Actions button for reviewer with project domain start */}
            {prevAnomalyId === null &&
              roleName === USER_ROLE.REVIEWER &&
              domainName === PROJECT_DOMAIN &&
              (detailedAnomalyStatus === UNREVIEWED ||
                detailedAnomalyStatus === AUDIT_REJECTED_UNREVIEWED ||
                detailedAnomalyStatus === BUSINESS_REJECTED_UNREVIEWED) && (
                <Button
                  className={`button--primary button-space ${rightSection && "disable"
                    }`}
                  type="primary"
                  size="small"
                  content={acknowledgedActionBtn}
                  data-testid="acknowledge-btn"
                  disabled={rightSection ? true : false}
                  onClick={() => {
                    setActiveAction("acknowledge");
                    setRightSection(true);
                  }}
                />
              )}

            {prevAnomalyId === null &&
              roleName === USER_ROLE.REVIEWER &&
              domainName === PROJECT_DOMAIN &&
              detailedAnomalyStatus === REVIEWED_ACTION_COMPLETE && (
                <Button
                  className={`button--primary disabled button-space ${rightSection && "disable"
                    }`}
                  type="primary"
                  size="small"
                  content={reviewedBtn}
                  data-testid="reviewed-btn"
                />
              )}

            {prevAnomalyId === null &&
              (roleName === USER_ROLE.REVIEWER ||
                roleName === USER_ROLE.ORG_USER ||
                roleName === USER_ROLE.POWER_USER ||
                roleName === USER_ROLE.DOMAIN_FOCAL) &&
              domainName === PROJECT_DOMAIN &&
              detailedAnomalyStatus === REVIEWED_ESCALATED && (
                <Button
                  className={`button--primary button-space ${rightSection && "disable"
                    }`}
                  type="primary"
                  size="small"
                  content={escalatedBtn}
                  data-testid="escalated-btn"
                  onClick={() => onEscalateClick()}
                />
              )}
            {/* Actions button for reviewer with project domain end */}
            {displayReviewTask(roleName, actionTrackingStatus) === "visible" ? (
              <Button
                className={`${roleName === ROLE_NAME.OWNER
                  ? "button--primary"
                  : "button--secondary"
                  } button-space ${rightSection && "disable"}`}
                iconPosition="right"
                size="small"
                type={roleName === ROLE_NAME.VIEWER ? "primary" : "secondary"}
                content={reviewTaskBtn}
                disabled={rightSection ? true : false}
                onClick={() => {
                  setActiveAction("review-task");
                  setRightSection(true);
                }}
              />
            ) : null}
            {getButtonStatus(
              roleName,
              opportunityStatus,
              detailedAnomalyStatus,
              { domainName, prevAnomalyId }
            ) && (
                <Button
                  className={`${roleName === USER_ROLE.ORG_USER &&
                    opportunityStatus === OPPORTUNITY_STATUS.REJECTED
                    ? "opp-org_user"
                    : "button--secondary"
                    } button-space ${rightSection && "disable"}`}
                  size="small"
                  type="secondary"
                  disabled={rightSection ? true : false}
                  onClick={() => {
                    setActiveAction("reject");
                    setRightSection(true);
                  }}
                  content={noActionReqBtn}
                />
              )}
            {currentOpportunity.status == "finished" &&
              getButtonStatus(
                roleName,
                opportunityStatus,
                detailedAnomalyStatus,
                { domainName, prevAnomalyId }
              ) && (
                <Button
                  className={`${roleName === USER_ROLE.ORG_USER &&
                    opportunityStatus === OPPORTUNITY_STATUS.ACCEPTED
                    ? "opp-org_user"
                    : "button--primary"
                    } button-space ${rightSection && "disable"}`}
                  icon={
                    enableRetryErr ? (
                      <Icon
                        root="building"
                        name="refresh"
                        exactSize={20}
                        className="actions-card__footer--retry"
                      />
                    ) : (
                      ""
                    )
                  }
                  iconPosition="right"
                  size="small"
                  type="primary"
                  content={actionReqBtn}
                  disabled={rightSection ? true : false}
                  data-testid="Accept-btn"
                  onClick={() => {
                    setActiveAction("accept");
                    setRightSection(true);
                  }}
                />
              )}
            {currentOpportunity.status == "finished" &&
              getReviewChecklistButton(opportunityStatus, roleName, domainName) &&
              <Button className="button--secondary button-space"
                iconPosition="right" size="small"
                // type={roleName === ROLE_NAME.VIEWER ? "primary" : "secondary"}
                content={reviewBtn}
                disabled={rightSection ? true : false}
                onClick={() => { setActiveAction('reviewer-checklist'); setRightSection(true); }}
              />
            }
          </div>
        )}
      </div>

      {downloadModal &&
        <div className="pdf-download-modal">
          <div className="pdf-download-modal-header">
            <div>{`Export Anomaly ${insightId} to PDF `}</div>
            <FontIcon
              iconName="fa fa-download"
              iconSize="large"
              className="export-icon"
              onClick={handleGeneratePdf}
            >
            </FontIcon>
          </div>
          <FontIcon
            iconName="fa fa-x"
            iconSize="large"
            className='download-close-icon'
            onClick={onDownloadClose}>
          </FontIcon>

          <div
            className="pdf-download-modal-content"
            ref={templateRef}
            key={`${insightId}-${new Date()}`}
            id={`insight-${insightId}`}
          >
            {anomalyContent(true)}
            {auditTrailContent()}
            {<ScufFooter copyrightText={`Honeywell Confidential- ©${new Date().getFullYear()} by Honeywell International Inc. All rights reserved.`}>
              <ScufFooter.Item href="https://sharepoint.honeywell.com/sites/PolicyManual/GPPS/GPPSHome.html?pn=2006&pl=en" target="_blank" >Privacy Statement</ScufFooter.Item>
              <ScufFooter.Item href="https://honeywellhub.secure.force.com/PrivacyInformationRequestForm?lang=en" >Do Not Sell My Personal Information</ScufFooter.Item>
              <ScufFooter.Item href="https://www.honeywell.com/en-us/privacy-statement#en-heading9" >Cookies</ScufFooter.Item>
              <ScufFooter.Item href="https://pages1.honeywell.com/GlobalHoneywellUnsubscribe.html" >Global Unsubscribe</ScufFooter.Item>
            </ScufFooter>}

          </div>

          <div className="downloadBtn">
            <Button type="primary" size="small" className="button--secondary button-space" content="Download" onClick={handleGeneratePdf} />
          </div>

        </div>
      }

    </>
  );
};

export default AnomalyDetails;
